import React from 'react';
import './privacy.policy.css';
import GetLangConfig from '../../util/LangUtil';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicy() {

    const history = useNavigate();
    const langConfig = GetLangConfig('privacypolicy');

    return (
        <div className="privacy-policy-container">
            <h1 dangerouslySetInnerHTML={{ __html: langConfig.privacypolicy.header }}></h1>
            <p>
                <span dangerouslySetInnerHTML={{ __html: langConfig.privacypolicy.p1 }}></span>
                <br/>
                <br/>
                <ol>
                    <li>{langConfig.privacypolicy.li1}</li>
                    <li>{langConfig.privacypolicy.li2}</li>
                    <li>{langConfig.privacypolicy.li3}</li>
                </ol>
            </p>
            <p>
                <span dangerouslySetInnerHTML={{ __html:langConfig.privacypolicy.p2 }}></span>
                <br/>
                <br/>
                <ul>
                    <li>{langConfig.privacypolicy.li4}</li>
                    <li>{langConfig.privacypolicy.li5}</li>
                    <li>{langConfig.privacypolicy.li6}</li>
                    <li>{langConfig.privacypolicy.li7}</li>
                </ul>
            </p>
            <p>
                {langConfig.privacypolicy.p3}<span className="terms-of-service" onClick={(e) => history('/termsofservice')}>{langConfig.privacypolicy.p4}</span>{langConfig.privacypolicy.p5}
            </p>
            <p>
                {langConfig.privacypolicy.p6}
            </p>
            <p>
                {langConfig.privacypolicy.p7}
            </p>
            <p>
                {langConfig.privacypolicy.p8}
            </p>
            <div>
                <div>{langConfig.privacypolicy.p9}</div>
                <p>
                    {langConfig.privacypolicy.p10}
                    <br/>
                    <br/>
                    <ol>
                        <li>{langConfig.privacypolicy.li8}</li>
                        <li>{langConfig.privacypolicy.li9}</li>
                        <li>{langConfig.privacypolicy.li10}</li>
                        <li>{langConfig.privacypolicy.li11}</li>
                        <li>{langConfig.privacypolicy.li12}</li>
                        <li>{langConfig.privacypolicy.li13}</li>
                        <li>{langConfig.privacypolicy.li14}</li>
                        <li>{langConfig.privacypolicy.li15}</li>
                        <li>{langConfig.privacypolicy.li16}</li>
                    </ol>
                </p>
                <p>
                    {langConfig.privacypolicy.p11}
                </p>
                <p>
                    {langConfig.privacypolicy.p12}
                </p>
            </div>
            <ol>
                <li>
                    <div>{langConfig.privacypolicy.p13}</div>
                    <p>
                        <span dangerouslySetInnerHTML={{ __html: langConfig.privacypolicy.p14 }}></span>
                        <ol>
                            <li>{langConfig.privacypolicy.p15}</li>
                            <li>{langConfig.privacypolicy.p16}</li>
                            <li>{langConfig.privacypolicy.p17}</li>
                            <li>{langConfig.privacypolicy.p18}</li>
                        </ol>
                    </p>
                    <p>
                        {langConfig.privacypolicy.p19}
                    </p>
                </li>
                <li>
                    <div>{langConfig.privacypolicy.p20}</div>
                    <p>
                        {langConfig.privacypolicy.p21}
                        <br/>
                        <br/>
                        <ol className='alpha-list'>
                            <li>{langConfig.privacypolicy.p22}</li>
                            <li>
                                <p>
                                    {langConfig.privacypolicy.p23}
                                </p>
                                <p>
                                    {langConfig.privacypolicy.p24}
                                </p>
                            </li>
                            <li><p>{langConfig.privacypolicy.p25}</p></li>
                        </ol>

                    </p>
                    <p>{langConfig.privacypolicy.p26}</p>
                    <p>{langConfig.privacypolicy.p27}</p>
                    <p>{langConfig.privacypolicy.p28}</p>
                </li>
                <li>
                    <div>{langConfig.privacypolicy.p29}</div>
                    <p>
                        {langConfig.privacypolicy.p30}
                        <br/>
                        <br/>
                        <ul className='disc-list'>
                            <li>{langConfig.privacypolicy.li17}</li>
                            <li>{langConfig.privacypolicy.li18}</li>
                            <li>{langConfig.privacypolicy.li19}</li>
                            <li>{langConfig.privacypolicy.li20}</li>
                            <li>{langConfig.privacypolicy.li21}</li>
                            <li>{langConfig.privacypolicy.li22}</li>
                            <li>{langConfig.privacypolicy.li23}</li>
                            <li>{langConfig.privacypolicy.li24}</li>
                            <li>{langConfig.privacypolicy.li25}</li>
                            <li>{langConfig.privacypolicy.li26}</li>
                            <li>{langConfig.privacypolicy.li27}</li>
                            <li>{langConfig.privacypolicy.li28}</li>
                            <li>{langConfig.privacypolicy.li29}</li>
                            <li>{langConfig.privacypolicy.li30}</li>
                        </ul>
                    </p>
                </li>
                <li>
                    <div>{langConfig.privacypolicy.p31}</div>
                    <p>{langConfig.privacypolicy.p32}</p>
                    <p>{langConfig.privacypolicy.p33}</p>
                    <p>{langConfig.privacypolicy.p34}</p>
                </li>
                <li>
                    <div>{langConfig.privacypolicy.p35}</div>
                    <p>{langConfig.privacypolicy.p36}</p>
                    <p>{langConfig.privacypolicy.p37}</p>
                    <p>{langConfig.privacypolicy.p38}</p>
                    <p>{langConfig.privacypolicy.p39}</p>
                    <p>{langConfig.privacypolicy.p40}</p>
                </li>
                <li>
                    <div>{langConfig.privacypolicy.p41}</div>
                    <p>{langConfig.privacypolicy.p42}</p>
                </li>
                <li>
                    <div>{langConfig.privacypolicy.p43}</div>
                    <p>{langConfig.privacypolicy.p44}</p>
                    <p>{langConfig.privacypolicy.p45}</p>
                </li>
                <li>
                    <div>{langConfig.privacypolicy.p46}</div>
                    <p>{langConfig.privacypolicy.p47}</p>
                    <p>{langConfig.privacypolicy.p48}</p>
                </li>
                <li>
                    <div>{langConfig.privacypolicy.p49}</div>
                    <p>{langConfig.privacypolicy.p50}</p>
                    <p>{langConfig.privacypolicy.p51}</p>
                    <p>{langConfig.privacypolicy.p52}</p>
                </li>
                <li>
                    <div>{langConfig.privacypolicy.p53}</div>
                    <p>{langConfig.privacypolicy.p54}</p>
                </li>
                <li>
                    <div>{langConfig.privacypolicy.p55}</div>
                    <p>{langConfig.privacypolicy.p56}</p>
                    <p>{langConfig.privacypolicy.p57}</p>
                </li>
                <li>
                    <div>{langConfig.privacypolicy.p58}</div>
                    <p>{langConfig.privacypolicy.p59}</p>
                    <p>{langConfig.privacypolicy.p60}</p>
                    <p>{langConfig.privacypolicy.p61}</p>
                </li>
                <li>
                    <div>{langConfig.privacypolicy.p62}</div>
                    <p>{langConfig.privacypolicy.p63}</p>
                    <p>{langConfig.privacypolicy.p64}</p>
                </li>



            </ol>
        </div>

    );
}
